<template>
  <v-dialog v-model="show" width="600" persistent>
    <v-form autocomplete="off" @submit.prevent="submit">
      <v-card class="mx-auto" outlined>
        <v-card-title class="headline">
          {{ isEdit ? 'Edit Canonical Exercise' : 'New Canonical Exercise' }}
        </v-card-title>

        <v-divider />

        <v-card-text class="py-5">
          <v-text-field
            v-model="form.name"
            label="Name"
            placeholder="Enter canonical exercise name"
            :error-messages="form.$getError('name')"
            :hide-details="!form.$getError('name')"
            outlined
            flat
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-6 pb-6 pt-5">
          <v-spacer />

          <v-btn
            class="px-12 error--text"
            text
            :disabled="form.$busy"
            @click="close"
          >
            Cancel
          </v-btn>

          <v-btn
            class="primary px-12"
            text
            type="submit"
            :loading="form.$busy"
            :disabled="form.$busy"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Form from '@/utils/form'
import { mapActions } from 'vuex'

export default {
  name: 'CanonicalExerciseFormDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    canonicalExercise: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      form: new Form({ id: null, name: null }),
    }
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },

    isEdit() {
      return !!(this.canonicalExercise && this.canonicalExercise.id)
    },
  },

  methods: {
    ...mapActions({
      saveCanonicalExercise: 'canonicalExercises/saveCanonicalExercise',
    }),

    async submit() {
      this.form.$busy = true
      this.form.$clearErrors()

      try {
        const saved = await this.saveCanonicalExercise(this.form.$data())
        this.form.$busy = false
        this.$emit('saved', saved)
        this.show = false
      } catch ({ response }) {
        this.form.$busy = false
        if (response && response.status === 422) {
          this.form.$setErrors(response.data.errors)
        }
      }
    },

    close() {
      this.show = false
    },
  },

  watch: {
    value(open) {
      if (open) {
        this.form = new Form({
          id: this.isEdit ? this.canonicalExercise.id : null,
          name: this.isEdit ? this.canonicalExercise.name : null,
        })
      }
    },
  },
}
</script>
